import React from "react";

function RightArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15.555"
      viewBox="0 0 16 15.555"
    >
      <path
        id="Path_18543"
        data-name="Path 18543"
        d="M16.172,11H4v2H16.172l-5.364,5.363,1.414,1.414L20,12,12.222,4.222,10.808,5.636Z"
        transform="translate(-4 -4.222)"
        fill="var(--primary-black)"
      />
    </svg>
  );
}

export default RightArrowIcon;
